import PropTypes from 'prop-types';
import clsx from 'clsx';
import Link from '@/components/Link';

const defaultProps = {
  children: 'Conocer más',
  className: '',
};

const propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default function LinkMore({ href, children, className }) {
  return (
    <Link
      href={href}
      className={clsx(
        'inline-flex items-center transition duration-100 ease-in-out',
        'space-x-1 text-lg font-medium text-green-500',
        'hover:text-gray-900',
        className
      )}
    >
      <div>{children}</div>
      <svg
        className="h-4 w-4"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
          clipRule="evenodd"
        />
      </svg>
    </Link>
  );
}

LinkMore.defaultProps = defaultProps;
LinkMore.propTypes = propTypes;
